// ============================================
// 공통 API ?�수 import
// - useApi: 로딩, ?�러처리, ?�션 ?�을 ?�동 처리?�는 ?�퍼 ?�수
// - useApi_multipart: multipart/form-data ?�송??
// ============================================
import { useApi } from '~/composables/useApi';
import { useApi_multipart } from '~/composables/useApi_multipart';
import type {
  SaveActualData,
  SaveKpiData,
  SaveObjectiveData,
  SaveKrData,
  SaveOkrFeedbackData,
  AgreementYnResponse,
  SaveAgreementRequest,
} from './useKpiTypes';

// ============================================
// KPI 관�?API ?�수 모음
// - Composable ?�턴: use~ ?�두?�로 Vue 3??Composition API 규칙 ?�름
// - ?�수�?반환?�는 ?�수 (Factory ?�턴)
// ============================================
export const useKpiApi = () => {
  /**
   * ============================================
   * KPI 목록 조회 API
   * ============================================
   *
   * @description KPI 목록 조회 (메인 ?�이블용)
   *
   * @param findYear - 조회?�도 (?? '2025')
   * @param userId - ?�?�자 ID (?�택, 미입????본인)
   *
   * @returns Promise<KpiListResponse>
   *   - kpiList: KPI 목록 배열
   */
  const fetchKpiList = (findYear: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/kpiList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // KPI 합의(Agreement) 기능 API
  // ============================================

  /**
   * KPI 합의 기능 사용 여부 조회 (AS-IS 그대로 호출)
   *
   * @description
   * - conf 설정 화면에서 저장한 "KPI 합의기능 사용여부"를 조회합니다.
   * - 응답은 'Y'/'N' 문자열이므로, 화면/스토어에서는 boolean으로 변환해서 씁니다.
   *
   * @param findYear - 조회 연도
   */
  const fetchAgreementYn = (findYear: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);

    return useApi('/api/hcm/kpi/kpiMng/selectAgreementYn.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    }) as unknown as Promise<AgreementYnResponse>;
  };

  /**
   * KPI 등록/수정 기간 여부(kpiConfigTermYn) 조회
   *
   * @description
   * - AS-IS에서는 `/hcm/kpi/kpiMng/kpi.do` 응답의 `kpiConfigTermYn`을 사용합니다.
   * - KPI ID가 없을 때도(내 KPI 목록만 보는 시점) 기간 플래그만 확인하려는 목적이라면
   *   백엔드가 허용하는 범위에서 kpiId 없이 호출될 수 있습니다.
   *
   * @param findYear - 조회 연도
   * @param kpiId - KPI ID(선택)
   */
  const fetchKpiConfigTermYn = (findYear: string, kpiId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (kpiId) params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/kpi.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI 합의 상태 저장(요청/취소/합의/반려/합의취소)
   *
   * @description
   * - AS-IS `saveAgreement.do`를 그대로 호출합니다.
   * - agreementCd 의미(AS-IS 기준)\n
   *   - 001: 합의요청\n
   *   - 002: 합의요청취소\n
   *   - 003: 합의\n
   *   - 004: 반려(사유 필수)\n
   *   - 005: 합의취소(사유 필수)\n
   */
  const saveAgreement = (data: SaveAgreementRequest) => {
    const params = new URLSearchParams();
    params.append('findYear', data.findYear);
    params.append('agreementCd', data.agreementCd);
    params.append('targetUserId', data.targetUserId);
    params.append('agreementUserId', data.agreementUserId);
    if (data.content) params.append('content', data.content);

    return useApi('/api/hcm/kpi/kpiMng/saveAgreement.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * ?�별 ?�적 목록 조회 API
   * ============================================
   *
   * @description ?�택??KPI???�별 ?�적 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   *
   * @returns Promise<ActualListResponse>
   *   - list: ?�별 ?�적 배열
   *     - actualId: ?�적 ID
   *     - actualMon: ?�적 ??(1~12)
   *     - targetVal: 목표�?
   *     - actualVal: ?�적�?
   *     - accumActualVal: ?�적 ?�적
   *     - accumAchieveRate: ?�적 ?�성�?
   *     - actualDesc: ?�적 ?�명
   *     - regDt: ?�록??
   */
  const fetchActualList = (findYear: string, userId: string, kpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/actualList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * ?�적 ?�세 조회 API
   * ============================================
   *
   * @description ?�적 ?�록/?�정 모달???�세 ?�보 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   * @param actualId - ?�적 ID (?�정 ??
   *
   * @returns Promise<ActualDetailResponse>
   *   - actual: ?�적 ?�세 ?�보
   */
  const fetchActual = (findYear: string, userId: string, kpiId: string, actualId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('kpiId', kpiId);
    if (actualId) params.append('actualId', actualId);

    return useApi('/api/hcm/kpi/kpiMng/actual.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * ?�적 ?�??API
   * ============================================
   *
   * @description ?�적 ?�록/?�정
   *
   * @param data - ?�?�할 ?�적 ?�이??
   *   - findYear: 조회?�도
   *   - userId: ?�?�자 ID
   *   - kpiId: KPI ID
   *   - actualId: ?�적 ID (?�정 ??
   *   - actualMon: ?�적 ??
   *   - actualVal: ?�적�?
   *   - actualDesc: ?�명
   *
   * @returns Promise<SaveResponse>
   *   - result: 'SUCCESS' / 'FAIL'
   */
  const saveActual = (data: SaveActualData) => {
    // 백엔?��? MultipartHttpServletRequest�?받으므�?FormData ?�용 (?�거?��? ?�일)
    const formData = new FormData();

    // 첨�??�일 관??메�? ?�라미터 (백엔??EgovFileMngService 규격)
    const files = data.files || [];
    const hasNewFiles = Array.isArray(files) && files.some((f: unknown) => f instanceof File);
    const deleteFileIds = data.deleteFileIds || [];
    const hasFilesToDelete = Array.isArray(deleteFileIds) && deleteFileIds.length > 0;

    // ?�규 ?�일 ?�로???�는 기존 ?�일 ??��가 ?�을 ???�일 메�? ?�보 ?�송
    if (hasNewFiles || hasFilesToDelete) {
      formData.append('inputFileNames', 'upload');
      formData.append('atchFileIds', data.atchFileId || 'NULL'); // 기존 ?�일ID (?�규??'NULL')
      formData.append('atchFileColumnNames', 'atchFileId');
      // 형식: {maxFileCnt}_{maxTotalSize}_{allowFileExts}
      // AS-IS 백엔드 fileUpload.defaultMaxSize=52428800(50MB), allowFileExts와 동일 정렬
      formData.append(
        'atchFileValidations',
        '5_52428800_jpg,jpeg,gif,png,bmp,txt,pdf,xls,xlsx,ppt,pptx,doc,docx,hwp,hwpx,heic,zip,7z,rar,alz,avi,mp4',
      );
    }

    // ?�규 ?�일 추�?
    if (hasNewFiles) {
      files.forEach((file: unknown) => {
        if (file instanceof File) {
          formData.append('upload', file);
        }
      });
    }

    // ??��???�일 ID 목록 (?�거?��? ?�일???�라미터�??�용)
    if (hasFilesToDelete) {
      const deleteFileSns = deleteFileIds.join(',');
      formData.append('chkAttachFiles', deleteFileSns); // ?�거???�라미터�?
      formData.append('upload_chkAttachFiles', deleteFileSns); // inputFileName_chkAttachFiles ?�식
    }

    // ?�머지 ?�이??추�? (files, deleteFileIds ?�외)
    Object.entries(data).forEach(([key, value]) => {
      if (key !== 'files' && key !== 'deleteFileIds' && value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });

    // multipart/form-data ?�송
    return useApi_multipart('/api/hcm/kpi/kpiMng/saveActual.do', {
      method: 'POST',
      body: formData,
    });
  };

  /**
   * ============================================
   * ?�적 ??�� API
   * ============================================
   *
   * @description ?�적 ??��
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   * @param actualId - ??��???�적 ID
   *
   * @returns Promise<DeleteResponse>
   *   - result: 'SUCCESS' / 'FAIL'
   */
  const deleteActual = (findYear: string, kpiId: string, mon: string) => {
    // ?�거?��? ?�일?�게 findYear, kpiId, mon?�로 ??��
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('kpiId', kpiId);
    params.append('mon', mon);

    return useApi('/api/hcm/kpi/kpiMng/deleteActual.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * ?�적 추�? 가????목록 조회 API
   * ============================================
   *
   * @description ?�직 ?�적???�록?��? ?��? ??목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   *
   * @returns Promise<MonthListResponse>
   *   - list: 추�? 가?�한 ??배열 (?? ['1', '2', '5'])
   */
  const fetchActualMonthList = (findYear: string, userId: string, kpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/selectActualMonList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * KPI 매핑 ?�무 목록 조회 API
   * ============================================
   *
   * @description KPI???�결???�무(Plan) 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   *
   * @returns Promise<TaskListResponse>
   *   - list: ?�무 목록 배열
   *     - planId: ?�무 ID
   *     - planNm: ?�무�?
   *     - planDesc: ?�무 ?�명
   */
  const fetchTaskList = (findYear: string, userId: string, kpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/selectCategoryPlan_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * ?�무 ?�동 목록 조회 API
   * ============================================
   *
   * @description ?�무(Plan)???�결???�동(Activity) 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param planId - ?�무 ID
   *
   * @returns Promise<ActivityListResponse>
   *   - list: ?�동 목록 배열
   *     - activityId: ?�동 ID
   *     - activityNm: ?�동�?
   */
  const fetchTaskActivityList = (findYear: string, userId: string, planId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('planId', planId); // Plan ID (?�무 ID)

    // Plan(?�무)???�결???�동 목록 조회
    return useApi('/api/hcm/kpi/kpiMng/selectKrPlanActivityList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * KPI 매핑 OKR 목록 조회 API
   * ============================================
   *
   * @description KPI???�결??OKR(Objective-KR) 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param kpiId - KPI ID
   *
   * @returns Promise<OkrListResponse>
   *   - list: OKR 목록 배열
   *     - krId: KR ID
   *     - krNm: KR�?
   *     - objectiveNm: 목표�?
   */
  const fetchOkrList = (findYear: string, userId: string, kpiId: string, cycleId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('kpiId', kpiId);
    if (cycleId) params.append('findCycleId', cycleId);

    return useApi('/api/hcm/kpi/kpiMng/selectObjectiveKr_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ============================================
   * OKR 매핑 ?�무 목록 조회 API
   * ============================================
   *
   * @description OKR(KR)???�결???�무(Plan) 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   * @param krId - KR ID
   *
   * @returns Promise<OkrTaskListResponse>
   *   - list: ?�무 목록 배열
   *     - planId: ?�무 ID
   *     - planNm: ?�무�?
   */
  const fetchOkrTaskMapping = (findYear: string, userId: string, krId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/selectKrPlanMapping.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR???�결??Plan 목록 조회 API (분기 ?�함)
   *
   * @description ?�터?�널?�서 KR ?�택 ???�결???�무 목록 조회
   *
   * @param findYear - 조회?�도
   * @param cycleId - 분기 ID
   * @param userId - ?�?�자 ID
   * @param krId - KR ID
   *
   * @returns Promise<KrPlanListResponse>
   *   - planList: ?�무 목록 배열
   */
  const fetchKrPlanList = (findYear: string, cycleId: string, userId: string, krId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (cycleId) params.append('findCycleId', cycleId);
    params.append('userId', userId);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/selectKrPlanMapping.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 활동탭 조회
   * planDatas: KR에 연결된 업무, activityDatas: 그 업무의 활동
   * 업무 모듈 selectData.do / activityList.do 를 대체한다.
   */
  const fetchObjPlanJson = (findYear: string, userId: string, krId: string, cycleId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('userId', userId);
    params.append('krId', krId);
    if (cycleId) params.append('findCycleId', cycleId);

    return useApi('/api/hcm/kpi/kpiMng/selectPlan_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // ??목표 추�? 관??API
  // ============================================

  /**
   * ?�위 KPI 목록 조회 API
   *
   * @description ??KPI ?�록 ???�위 KPI ?�택??목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   *
   * @returns Promise<UpKpiListResponse>
   *   - list: ?�위 KPI 목록 배열
   */
  const fetchUpKpiList = (findYear: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/selectUpKpiList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 부??KPI 목록 조회 API
   *
   * @description KPI 구분??'부??????부??KPI ?�택??목록 조회
   *
   * @param findYear - 조회?�도
   * @param deptId - 부??ID (?�택, 미입????로그???�용?�의 부??
   *
   * @returns Promise<DeptKpiListResponse>
   *   - deptKpiList: 부??KPI 목록 배열
   *     - id: KPI ID
   *     - text: KPI�?
   */
  const fetchDeptKpiList = (findYear: string, deptId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (deptId) params.append('findDeptId', deptId);

    return useApi('/api/hcm/kpi/kpiMng/myDeptkpiList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 참고 KPI 목록 조회 API
   *
   * @description 참고 KPI ?�택 모달??목록 조회
   *
   * @param taskGbnId - 부�?ID (?? '001')
   * @param searchRefKpiNm - 검???�워??(?�과지?�명)
   *
   * @returns Promise<RefKpiListResponse>
   *   - referenceKpiList: 참고 KPI 목록 배열
   *     - refKpiNm: KPI�?
   *     - description: ?�의
   *     - actCalTypeNm: ?�출??
   *     - unit: ?�위
   *     - taskGbnId, taskGbnNm: 부�?
   *   - taskGbnList: 부�?목록 배열
   *     - taskGbnId, taskGbnNm
   */
  const fetchRefKpiList = (taskGbnId?: string, searchRefKpiNm?: string) => {
    const params = new URLSearchParams();
    if (taskGbnId) params.append('taskGbnId', taskGbnId);
    if (searchRefKpiNm) params.append('searchRefKpiNm', searchRefKpiNm);

    return useApi('/api/org/kpi/orgKpiMng/selectReferenceKpiData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI ?�??API
   *
   * @description ??KPI ?�록 ?�는 ?�정 (kpiId ?�무�?구분)
   *
   * @param data - ?�?�할 KPI ?�이??
   *
   * @returns Promise<SaveResponse>
   */
  const saveKpi = (data: SaveKpiData) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    return useApi('/api/hcm/kpi/kpiMng/saveKpi.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI ??�� API
   *
   * @description KPI ??�� (?�결???�적, ?�무, OKR???�께 ??��??
   *
   * @param kpiId - ??��??KPI ID
   * @param findYear - 조회?�도
   *
   * @returns Promise<DeleteResponse>
   *   - result: 'SUCCESS' / 'FAIL'
   */
  const deleteKpi = (kpiId: string, findYear: string) => {
    const params = new URLSearchParams();
    params.append('kpiId', kpiId);
    params.append('findYear', findYear);

    return useApi('/api/hcm/kpi/kpiMng/deleteKpi.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI 복사 실행 API (다른 연도로 KPI 마스터 행만 복사)
   *
   * @description AS-IS copyKpi — hcm_kpi 마스터 행만 INSERT-new. 하위 OKR/업무/실적 등은 복사되지 않음.
   *
   * @param findYear - 원본 연도
   * @param copyYear - 대상 연도
   * @param kpiId - 복사할 원본 KPI ID
   *
   * @returns Promise<SaveResponse>
   */
  const copyKpi = (findYear: string, copyYear: string, kpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('copyYear', copyYear);
    params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/copyKpi.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // ?�과 ?�동 관??API
  // ============================================

  /**
   * ?�결 가?�한 OKR(KR) 목록 조회 API (fetchOkrList?� ?�일 ?�드?�인??
   * @description fetchOkrList??alias - KPI ?�록 ???�결??
   */
  const fetchLinkableOkrList = (findYear: string, userId?: string, cycleId?: string) => {
    return fetchOkrList(findYear, userId || '', '', cycleId);
  };

  /**
   * ?�결 가?�한 ?�무(Plan) 목록 조회 API
   *
   * @description KPI ?�록 ???�결?????�는 ?�무 목록 조회
   *
   * @param findYear - 조회?�도
   * @param userId - ?�?�자 ID
   *
   * @returns Promise<PlanListResponse>
   */
  const fetchLinkablePlanList = (findYear: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (userId) {
      params.append('userId', userId);
      params.append('findUserId', userId);
    }

    return useApi('/api/hcm/kpi/kpiMng/selectCategoryPlan_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 공유 ?�???�용??목록 조회 API
   *
   * @description 목표/?�적 공유 ?�???�용??목록 조회
   *
   * @param findYear - 조회?�도
   * @param kpiId - KPI ID (?�정 ??
   *
   * @returns Promise<ShareUserListResponse>
   */
  const fetchShareUserList = (findYear: string, kpiId?: string, shareTypeCd?: 'team' | 'share') => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (kpiId) params.append('kpiId', kpiId);
    if (shareTypeCd) params.append('shareTypeCd', shareTypeCd);

    return useApi('/api/hcm/kpi/kpiMng/shareUserList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ?�전?�도 KPI 목록 조회 API (fetchKpiList?� ?�일 ?�드?�인??
   * @description fetchKpiList??alias - ?�전?�도 KPI ?�결??
   */
  const fetchPrevYearKpiList = fetchKpiList;

  /**
   * 배포 KPI ?�락 API
   *
   * @description 배포??KPI�??�락 (받기)
   *
   * @param findYear - 조회?�도
   * @param disKpiId - 배포 KPI ID
   *
   * @returns Promise<AcceptKpiResponse>
   *   - kpi: ?�락??KPI ?�보
   *   - distributeKpiList: ?��? 배포 KPI 목록
   */
  const acceptDistributeKpi = (findYear: string, disKpiId: string, disUpKpiId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('year', findYear);
    params.append('kpiId', disKpiId); // 배포 KPI ID (JSP 방식�??�일)
    if (disUpKpiId) {
      params.append('upKpiId', disUpKpiId); // ?�위 KPI ID
    }

    return useApi('/api/hcm/kpi/kpiMng/updateDistributeKpiData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 로그???�용???�보 조회 API
   *
   * @description ?�재 로그?�한 ?�용?�의 ?�세 ?�보 조회 (부???�함)
   *
   * @returns Promise<UserInfoResponse>
   *   - userinfo: ?�용???�보
   *     - userId: ?�용??ID
   *     - userNm: ?�용?�명
   *     - deptId: 부??ID
   *     - deptNm: 부?�명
   *     - posNm: 직위�?
   *     - jikgubNm: 직급�?
   */
  const fetchLoginUserInfo = () => {
    return useApi('/api/auth/userinfo', {
      method: 'GET',
    });
  };

  // ============================================
  // OKR 분기(Cycle) 관??API
  // ============================================

  /**
   * 분기(Cycle) 목록 조회 API
   *
   * @description ?�당 ?�도??OKR 분기 목록 조회
   *
   * @param findYear - 조회?�도
   *
   * @returns Promise<CycleListResponse>
   *   - cycleList: 분기 목록 배열
   *     - cycleId: 분기 ID
   *     - cycleNm: 분기�?(?? 1분기, 2분기, ?�반�? ?�반�?
   */
  const fetchCycleList = (findYear: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);

    return useApi('/api/hcm/kpi/kpiMng/selectCycleList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 분기�?OKR 목록 조회 API
   *
   * @description ?�정 분기??OKR(Objective + KR) 목록 조회
   *
   * @param findYear - 조회?�도
   * @param findCycleId - 분기 ID
   * @param userId - ?�?�자 ID
   *
   * @returns Promise<OkrListResponse>
   *   - objDatas: Objective + KR 목록
   */
  const fetchOkrListByCycle = (findYear: string, findCycleId: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    // AS-IS 컨트롤러가 userId�?받아??objectiveSearchUserId�??�정??
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/selectObjKrData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // OKR(KR) 관??API
  // ============================================

  /**
   * Objective ?�??API (?�성/?�정)
   *
   * @param data - { year, cycleId, objId?, objNm }
   * @returns Promise<{ objId: string }>
   */
  const saveObjective = (data: SaveObjectiveData) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        // value가 undefined ?�는 null???�닌 경우?�만 추�?
        params.append(key, String(value)); // key?� value�?추�?
      }
    });

    return useApi('/api/hcm/kpi/kpiMng/insertObjective.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * Objective 삭제 API
   *
   * @description KR 없는 독립 OKR(목적) 삭제
   *
   * @param year - 연도
   * @param cycleId - 분기 ID
   * @param objId - 삭제할 Objective ID
   *
   * @returns Promise<DeleteResponse>
   */
  const deleteObjective = (year: string, cycleId: string, objId: string) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('objId', objId);

    return useApi('/api/hcm/kpi/kpiMng/deleteObjective.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI-KR 연계 저장 API
   *
   * @description KPI에 KR 목록을 연결(연계)한다.
   *
   * @param year - 연도
   * @param kpiId - 대상 KPI ID
   * @param krIds - 연결할 KR ID 목록 (콤마 구분 문자열)
   * @param planIds - 연결할 Plan ID 목록 (콤마 구분 문자열, 없으면 빈 문자열)
   *
   * @returns Promise<SaveResponse>
   */
  const linkKpiKr = (year: string, kpiId: string, krIds: string, planIds = '') => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('kpiId', kpiId);
    params.append('krIds', krIds);
    params.append('planIds', planIds);

    return useApi('/api/hcm/kpi/kpiMng/saveKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 구성원/공유자 목록 조회 API (MemberPanel 탭용)
   *
   * @description 나를 매니저로 등록한 사람 + 나를 공유자로 등록한 사람 목록 조회
   *
   * @param findYear - 조회연도
   * @param findCycleId - 분기 ID
   * @param shareTypeCd - 조회 타입 ('team': 구성원, 'share': 공유자)
   *
   * @returns Promise<MemberShareListResponse>
   *   - searchUserList: 구성원/공유자 목록
   *     - searchUserId: 사용자 ID
   *     - searchUserNm: 사용자명
   *     - jikgubNm: 직급명
   *     - deptNm: 부서명
   */
  const fetchMemberShareList = (
    findYear: string,
    findCycleId: string,
    shareTypeCd: 'team' | 'share' = 'team',
  ) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    params.append('shareTypeCd', shareTypeCd);

    return useApi('/api/hcm/kpi/kpiMng/selectSearchUserData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * OKR(KR) ?�??API (?�규)
   *
   * @description ??KR ?�록
   *
   * @param data - ?�?�할 KR ?�이??
   *   - year: ?�도
   *   - userId: ?�?�자 ID
   *   - objId: Objective ID
   *   - objNm: Objective�?(?�규 Objective ?�성 ??
   *   - krNm: KR�?
   *   - startDt: ?�작??(YYYYMMDD)
   *   - endDt: 종료??(YYYYMMDD)
   *   - weight: 가중치
   *   - content: ?�용
   *   - evalTargetGbnCd: ?��??�?�여부 (001: ?�?? 002: 미�???
   *
   * @returns Promise<SaveResponse>
   */
  const insertOkr = (data: SaveKrData) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    return useApi('/api/hcm/kpi/kpiMng/insertKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * OKR(KR) ?�정 API
   *
   * @description KR ?�정
   *
   * @param data - ?�정??KR ?�이??
   *   - year: ?�도
   *   - userId: ?�?�자 ID
   *   - krId: KR ID
   *   - krNm: KR�?
   *   - startDt: ?�작??(YYYYMMDD)
   *   - endDt: 종료??(YYYYMMDD)
   *   - weight: 가중치
   *   - content: ?�용
   *   - performMeasMtd: ?�과측정방법 (001: 비계?? 002: 계량)
   *   - performTarget: ?�과목표 (계량????
   *   - unit: ?�위 (계량????
   *   - evalTargetGbnCd: ?��??�?�여부
   *
   * @returns Promise<UpdateResponse>
   */
  const updateOkr = (data: SaveKrData) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    return useApi('/api/hcm/kpi/kpiMng/updateKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * OKR(KR) 삭제 API
   *
   * @description KR 삭제
   *
   * @param year - 연도
   * @param krId - 삭제할 KR ID
   * @param cycleId - 분기 ID
   *
   * @returns Promise<DeleteResponse>
   */
  const deleteOkr = (year: string, krId: string, cycleId?: string) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('krId', krId);
    params.append('cycleId', cycleId || '');

    return useApi('/api/hcm/kpi/kpiMng/deleteKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR ?�세 조회 API
   *
   * @description KR ?�세 ?�보 조회
   *
   * @param findYear - 조회?�도
   * @param krId - KR ID
   *
   * @returns Promise<KrDetailResponse>
   *   - detailData: KR ?�세 ?�보
   *     - krId, krNm: KR ID/�?
   *     - objId, objNm: 목적 ID/�?
   *     - startDt, endDt: 기간
   *     - weight: 가중치
   *     - performMeasMtd, performMeasNm: 측정방식
   *     - statusCd, statusNm: ?�태
   *     - refUserNm: 참조??
   */
  const fetchKrDetail = (findYear: string, krId: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('krId', krId);
    // 다른 사용자의 KR 조회 시 userId 필요 (백엔드: objectiveSearchUserId로 사용)
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/selectKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR ?�태 목록 조회 API
   *
   * @description KR ?�태 ?�션 (?�수/보통/미흡) �?관???�이??조회
   *
   * @param findYear - 조회?�도
   * @param krId - KR ID
   *
   * @returns Promise<KrStatusResponse>
   *   - statusList: ?�태 목록 [{statusCd, statusNm, color}]
   *   - weightUseYn: 가중치 ?�용 ?��?
   */
  const fetchKrStatusList = (findYear: string, krId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/selectStatusData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // KR 관계맺기 관련 API
  // ============================================

  /**
   * 관계맺기 매니저 목록 조회 API
   *
   * @description 현재 사용자의 매니저 목록 조회 (관계맺기용)
   *
   * @returns Promise<RelKrManagerListResponse>
   *   - managerList: 매니저 목록 [{ id, text }] (대문자 주의)
   */
  const fetchRelKrManagerList = () => {
    return useApi('/api/hcm/kpi/kpiMng/selectRelKrManagerList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: '',
    });
  };

  /**
   * 관계맺기 KR 목록 조회 API
   *
   * @description 선택한 매니저의 KR 목록 조회 (순환 참조 방지 포함)
   *
   * @param userId - 매니저 ID
   * @param findYear - 조회연도
   * @param cycleId - 분기 ID
   * @param krId - 현재 KR ID (순환 참조 방지용)
   *
   * @returns Promise<RelationKrListResponse>
   *   - list: KR 목록 [{ id, text }] (대문자 주의)
   */
  const fetchRelationKrList = (
    userId: string,
    findYear: string,
    cycleId?: string,
    krId?: string,
  ) => {
    const params = new URLSearchParams();
    params.append('userId', userId);
    params.append('findYear', findYear);
    if (cycleId) params.append('cycleId', cycleId);
    if (krId) params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/selectRelationKrList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  const saveKrPlan = (year: string, krId: string, planIds: string) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('krId', krId);
    params.append('planIds', planIds);

    return useApi('/api/hcm/kpi/kpiMng/savePlan.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 타임라인(간트) 조회 API
   *
   * @description AS-IS component-kr-gantt (common.vue.jsp L1882) 와 동일 엔드포인트.
   *   krList = KR 행(그룹), planList = 각 KR 에 연결된 업무 행.
   *   월별 건수(m1~m12)와 색(m1StatusColor~) 필드명이 업무 타임라인과 같아
   *   managerGanttUtils 의 cellBadges/barColor 를 그대로 쓸 수 있다.
   *
   * @param findYear - 조회연도
   * @param findCycleId - 분기 ID
   * @param findUserId - 대상 사용자 ID
   *
   * @returns { krList, planList }
   */
  const fetchKrGanttList = (findYear: string, findCycleId: string, findUserId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    params.append('findUserId', findUserId);

    return useApi('/api/hcm/kpi/kpiMng/ganttList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 연계도 대상 KR 목록 조회 API
   *
   * @description Cascading 모달의 KR 셀렉트를 채운다.
   *   AS-IS component-kr-cascading-modal.getCascadingKrList (common.vue.jsp L1757).
   *   한 사람의 연계도는 사슬(root) 단위로 여러 개라 먼저 목록을 받고,
   *   고른 rootKrId 로 fetchKrCascadingTree 를 호출하는 2단계 구조다.
   *
   * @param findYear - 조회연도
   * @param findUserId - 대상 사용자 ID
   * @param findCycleId - 분기 ID
   *
   * @returns cascadingKrList: [{ rootKrId, krNm }]
   */
  const fetchCascadingKrList = (findYear: string, findUserId: string, findCycleId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findUserId', findUserId);
    params.append('findCycleId', findCycleId);

    return useApi('/api/hcm/kpi/kpiMng/selectCascadingKrList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 연계도(Cascading) 트리 조회 API
   *
   * @description AS-IS SvgTree와 동일한 다단계 cascade 데이터 조회.
   *   백엔드는 selectKrCascadingRelList 결과를 nodeRemoveCnt로 중첩 처리한
   *   "이미 트리화된 XML"을 반환한다(엔드포인트명은 _json 이지만 실제 text/xml).
   *   → JSON 파싱하지 말고 XML 문자열 원본을 받아야 하므로 responseType:'text',
   *     unescapeHTML 간섭 방지를 위해 skipUnescape:true 를 지정한다.
   *
   * @param findYear - 조회연도
   * @param findCycleId - 분기 ID
   * @param krId - 기준 KR ID (INSTR(REL_KR_FULL_ID, krId)로 포함된 전체 사슬 조회)
   * @param findUserId - 대상 사용자 ID (다른 사용자 KR 조회 시, 선택)
   *
   * @returns Promise<string> KR 연계도 XML 문자열 (<root><node>...</node></root>)
   */
  const fetchKrCascadingTree = (
    findYear: string,
    findCycleId: string,
    krId: string,
    findUserId = '',
  ) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    params.append('krId', krId);
    if (findUserId) params.append('findUserId', findUserId);

    return useApi('/api/hcm/kpi/kpiMng/krCascadingList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
      responseType: 'text', // XML 문자열 원본 수신 (JSON 자동 파싱 방지)
      skipUnescape: true, // unescapeHTML 이 XML 구조를 훼손하지 않도록
    });
  };

  // ============================================
  // OKR ?�드�?관??API
  // ============================================

  /**
   * OKR ?�드�?조회 API
   *
   * @description KR???�???�드�?목록 조회
   *
   * @param year - ?�도
   * @param cycleId - 분기 ID
   * @param userId - ?�?�자 ID
   * @param krId - KR ID
   *
   * @returns Promise<FeedbackResponse>
   *   - feedbackDatas: ?�드�?목록
   *   - statusList: ?�태 ?�션 (?�수/보통/미흡)
   *   - checkFeedbackYn: ?�드�??�정 ?��?
   */
  const fetchOkrFeedback = (year: string, cycleId: string, userId: string, krId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', year);
    params.append('findCycleId', cycleId);
    params.append('objectiveSearchUserId', userId);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/selectFeedback_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 피드백 읽음 처리 API
   * AS-IS objMngList.jsp 동일 — feedbackId 생략 시 해당 KR 전체 읽음
   * (loginUserId·compId 는 서버 세션에서 주입되므로 전송 불필요)
   */
  const fetchUpdateKrFeedbackRead = (
    year: string,
    cycleId: string,
    krId: string,
    feedbackId?: string,
  ) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('findCycleId', cycleId);
    params.append('krId', krId);
    // feedbackId 있으면 해당 피드백 1건만, 없으면 KR 전체 읽음 (AS-IS 동일)
    if (feedbackId) params.append('feedbackId', feedbackId);

    return useApi('/api/hcm/kpi/kpiMng/updateNewReadData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * OKR ?�드�??�??API
   *
   * @description ?�드�??�??(?�규/?�정)
   *
   * @param data - ?�드�??�이??
   *   - year: ?�도
   *   - cycleId: 분기 ID
   *   - userId: ?�?�자 ID
   *   - krId: KR ID
   *   - content: ?�드�??�용
   *   - achive: ?�성�?(%)
   *   - statusCd: ?�태 코드 (S001:?�수, S002:보통, S003:미흡)
   *   - feedbackRatingId: 별점 (1~5)
   *   - feedbackId: ?�드�?ID (?�정 ??
   *
   * @returns Promise<SaveResponse>
   */
  const saveOkrFeedback = (data: SaveOkrFeedbackData) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });

    // 신규/수정 모두 동일 엔드포인트 (feedbackId 유무로 서버에서 분기)
    const url = '/api/hcm/kpi/kpiMng/insertFeedback.do';

    return useApi(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * OKR ?�드�???�� API
   *
   * @description ?�드�???��
   *
   * @param year - ?�도
   * @param cycleId - 분기 ID
   * @param userId - ?�?�자 ID
   * @param krId - KR ID
   * @param feedbackId - ?�드�?ID
   *
   * @returns Promise<DeleteResponse>
   */
  const deleteOkrFeedback = (
    year: string,
    cycleId: string,
    userId: string,
    krId: string,
    feedbackId: string,
  ) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('findYear', year);
    params.append('cycleId', cycleId);
    params.append('findCycleId', cycleId);
    params.append('krId', krId);
    params.append('feedbackId', feedbackId);
    params.append('userId', userId);

    // ⚠️ 반드시 objMng 엔드포인트 사용 (AS-IS objMngList.jsp 동일).
    // personalTimeLine/deleteFeedback.do 는 전체관리자(01)/인사담당(12)/부서장(03)
    // 전용 authCheck 가 걸려 있어, 일반 사용자(KPI 매니저)가 본인 작성 OKR 피드백을
    // 삭제 시 "권한이 없습니다." 로 거부됨. objMng 삭제 SQL 의 CREATE_USER_ID =
    // loginUserId 가 작성자 본인 검증을 이미 담당함.
    return useApi('/api/hcm/kpi/kpiMng/deleteObjFeedback.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // 구성???�리 조회 API (MemberPanel??
  // ============================================

  /**
   * 구성???�리 목록 조회 API
   *
   * @description MemberPanel??조직???�리 조회 (계층 구조)
   *              - findDeptId, findUserId 모두 ?�으�? 로그???�용??기�? ?�이?�라??조회 (?? + ??+ ?�래)
   *              - findDeptId ?�는 findUserId ?�으�? PARENT_ID??null 반환
   *
   * @param findYear - 조회?�도
   * @param findDeptId - 부??ID (?�택)
   * @param findUserId - ?�용??ID (?�택)
   *
   * @returns Promise<MemberTreeResponse>
   *   - memberTreeList: 구성???�리 배열
   *     - USER_ID: ?�용??ID
   *     - USER_NM: ?�용?�명
   *     - JIKGUB_NM: 직급�?
   *     - POS_NM: 직위�?
   *     - DEPT_NM: 부?�명
   *     - PARENT_ID: 부�?ID (계층 구조??
   *     - KPI_RATE: KPI ?�성�?
   *     - IS_ME: 본인 ?��? ('Y'/'N')
   */
  const fetchMemberTreeList = (findYear: string, findDeptId?: string, findUserId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (findDeptId) params.append('findDeptId', findDeptId);
    if (findUserId) params.append('findUserId', findUserId);

    return useApi(`/api/hcm/kpi/kpiMng/selectMemberTreeList.do?${params.toString()}`, {
      method: 'GET',
    });
  };

  /**
   * KPI ?�하???�결관�?조회 API
   *
   * @description KPI ?�계???�시???�하???�결 KPI 조회
   *
   * @param findYear - 조회?�도
   * @param findKpiId - KPI ID
   *
   * @returns Promise<KpiLinkDataResponse>
   *   - parentKpi: ?�위 ?�결 KPI (?�으�?null)
   *   - currentKpi: ?�재 KPI ?�보
   *   - childKpiList: ?�위 ?�결 KPI 목록 (?�으�?�?배열)
   */
  const fetchKpiLinkData = (findYear: string, findKpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findKpiId', findKpiId);

    return useApi(`/api/hcm/kpi/kpiMng/selectKpiLinkData.do?${params.toString()}`, {
      method: 'GET',
    });
  };

  // ============================================
  // 검??조건 관??API (관리자??
  // ============================================

  /**
   * 부??목록 조회 API (관리자??
   *
   * @description 관리자가 검?�할 ???�는 부??목록 조회
   *
   * @returns Promise<DeptListResponse>
   *   - list: 부??목록 배열
   *     - deptId: 부??ID
   *     - deptNm: 부?�명
   */
  const fetchKpiDeptList = () => {
    return useApi('/api/hcm/kpi/kpiMng/deptList_json.do', {
      method: 'GET',
    });
  };

  /**
   * ?�용??목록 조회 API (부??기�? ?�위 조직 ?�함)
   *
   * @description ?�정 부???�는 로그???�용??부??기�? ?�위 조직 ?�함 ?�용??목록 조회
   *
   * @param findDeptId - 부??ID (?�택, 미입????로그???�용??부??기�?)
   *
   * @returns Promise<UserListResponse>
   *   - list: ?�용??목록 배열
   *     - userId: ?�용??ID
   *     - userNm: ?�용?�명
   *     - deptNm: 부?�명
   *     - posNm: 직위�?
   */
  const fetchKpiUserList = (findDeptId?: string) => {
    const params = findDeptId ? `?findDeptId=${findDeptId}` : '';
    return useApi(`/api/hcm/kpi/kpiMng/userList_json.do${params}`, {
      method: 'GET',
    });
  };

  // ============================================
  // ?�스???�정 관??API
  // ============================================

  /**
   * KPI 진행?�태 목록 조회 API (?�스???�정)
   *
   * @description ?�스???�정?�서 ?�록??KPI 진행?�태 목록 조회
   *
   * @param kpiYear - ?�도 (?? '2026')
   *
   * @returns Promise<KpiStatusListResponse>
   *   - kpiStatusList: 진행?�태 목록 배열
   *     - statusCd: ?�태 코드
   *     - statusNm: ?�태�?
   *     - color: ?�상 코드
   *     - progressRate: 진척�?
   *     - sortOrder: ?�렬 ?�서
   */
  const fetchKpiStatusList = (kpiYear: string) => {
    const params = new URLSearchParams();
    params.append('kpiYear', kpiYear);
    params.append('cycleYear', kpiYear);
    params.append('statusYear', kpiYear);
    params.append('idpYear', kpiYear);

    return useApi('/api/hcm/conf/confMng/selectConfData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // ?�서 변�?API
  // ============================================

  /**
   * KPI ?�렬?�서 ?�정 API
   *
   * @description KPI 목록???�렬 ?�서�??�??
   *
   * @param year - ?�도 (?? '2025')
   * @param kpiIds - KPI ID 배열 (?�서?��?
   *
   * @returns Promise<UpdateSortOrderResponse>
   *   - kpiList: ?�데?�트??KPI 목록
   */
  const updateKpiSortOrder = (year: string, kpiIds: string[]) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('findYear', year);
    params.append('kpiIds', kpiIds.join('|')); // ?�이??구분??

    return useApi('/api/hcm/kpi/kpiMng/updateSortOrder.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * Objective ?�렬?�서 ?�정 API
   *
   * @description Objective 목록???�렬 ?�서�??�??
   *
   * @param year - ?�도 (?? '2025')
   * @param cycleId - 분기 ID
   * @param objIds - Objective ID 배열 (?�서?��?
   *
   * @returns Promise<UpdateObjSortResponse>
   */
  const updateObjSortOrder = (year: string, cycleId: string, objIds: string[]) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('objSortIds', objIds.join(',')); // 콤마 구분??

    return useApi('/api/hcm/kpi/kpiMng/updateObjSortData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR ?�렬?�서 ?�정 API
   *
   * @description KR 목록???�렬 ?�서�??�??
   *
   * @param year - ?�도 (?? '2025')
   * @param cycleId - 분기 ID
   * @param objId - ?�속 Objective ID
   * @param krIds - KR ID 배열 (?�서?��?
   *
   * @returns Promise<UpdateKrSortResponse>
   */
  const updateKrSortOrder = (year: string, cycleId: string, objId: string, krIds: string[]) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('objId', objId);
    params.append('krSortIds', krIds.join(',')); // 콤마 구분??
    params.append('krSenderSortIds', '');
    params.append('senderObjId', '');

    return useApi('/api/hcm/kpi/kpiMng/updateKrSortData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // 배포받�? KPI 목록 조회 API
  // ============================================

  /**
   * 배포받�? KPI 목록 조회 API
   *
   * @description 배포받�? KPI 목록 조회
   *
   * @param findYear - 조회?�도
   *
   * @returns Promise<DistributeKpiListResponse>
   */
  const fetchDistributeKpiList = (findYear: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    return useApi('/api/hcm/kpi/kpiMng/selectDistributeKpiData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 배포받은 KR 목록 조회 API
   *
   * @param findYear - 조회연도
   * @param findCycleId - 분기 ID
   *
   * @returns Promise<{ distributeKrList: DistributeKrItem[] }>
   */
  const fetchDistributeKrList = (findYear: string, findCycleId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    return useApi('/api/hcm/kpi/kpiMng/selectDistributeKrData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 배포 KR 수락 API
   *
   * @param year - 연도
   * @param cycleId - 분기 ID
   * @param krId - 배포 KR ID
   * @param objId - 목적(Objective) ID
   */
  const acceptDistributeKr = (year: string, cycleId: string, krId: string, objId: string) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('krId', krId);
    params.append('objId', objId);
    return useApi('/api/hcm/kpi/kpiMng/updateDistributeKrData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * ?�체 ?�용??부??목록 조회 API (?�정 모달 ?�션??
   */
  const fetchAllUserList = () => {
    return useApi('/api/common/userAllList_json.do?isIncludeDept=Y', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: '',
    });
  };

  /**
   * KPI ?�정 조회 API (매니?�/공유??
   */
  const fetchKpiSetting = (findYear: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);

    return useApi('/api/hcm/kpi/kpiMng/setting.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI ?�정 ?�??API (매니?�/공유??
   */
  const saveKpiSetting = (year: string, managerIds: string[], shareUserIds: string[]) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('managerIds', managerIds.join(','));
    params.append('shareUserIds', shareUserIds.join(','));

    return useApi('/api/hcm/kpi/kpiMng/saveBoardData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // OKR 설정 관련 API
  // ============================================

  /**
   * OKR 설정 조회 API (매니저/공유자)
   */
  const fetchOkrSetting = (findYear: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);

    return useApi('/api/hcm/kpi/kpiMng/selectSettingDetailData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * OKR 설정 저장 API (매니저/공유자)
   */
  const saveOkrSetting = (year: string, managerIds: string[], shareUserIds: string[]) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('managerIds', managerIds.join(','));
    params.append('shareUserIds', shareUserIds.join(','));

    return useApi('/api/hcm/kpi/kpiMng/saveObjBoardData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // KPI ?�드�?관??API
  // ============================================

  /**
   * KPI ?�드�??�록 가????조회 API
   *
   * @param year - ?�도
   * @param kpiId - KPI ID
   *
   * @returns Promise<{ feedbackMonList: string[] }>
   */

  /**
   * KPI ?�드�??�세 조회 API
   *
   * @param year - ?�도
   * @param kpiId - KPI ID
   * @param mon - ??
   *
   * @returns Promise<{ feedback: { year, kpiId, feedbackMon, feedback } }>
   */
  const fetchKpiFeedback = (year: string, kpiId: string, mon: string) => {
    const params = new URLSearchParams();
    params.append('findYear', year);
    params.append('kpiId', kpiId);
    params.append('mon', mon);

    return useApi('/api/hcm/kpi/kpiMng/feedback.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  const fetchKpiFeedbackMonList = (year: string, kpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', year);
    params.append('kpiId', kpiId);

    return useApi('/api/hcm/kpi/kpiMng/selectFeedbackMonList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI ?�드�??�??API
   *
   * @param year - ?�도
   * @param kpiId - KPI ID
   * @param kpiNm - KPI�?
   * @param mon - ??
   * @param feedback - ?�드�??�용
   *
   * @returns Promise<SaveResponse>
   */
  const saveKpiFeedback = (
    year: string, // ?�도
    kpiId: string, // KPI ID
    kpiNm: string, // KPI�?
    mon: string, // ??
    feedback: string, // ?�드�??�용
  ) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('kpiId', kpiId);
    params.append('kpiNm', kpiNm);
    params.append('mon', mon);
    params.append('feedback', feedback);

    return useApi('/api/hcm/kpi/kpiMng/saveFeedback.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KPI ?�드�???��
   *
   * @param year - ?�도
   * @param kpiId - KPI ID
   * @param mon - ??
   */
  const deleteKpiFeedback = (year: string, kpiId: string, mon: string) => {
    const params = new URLSearchParams();
    // 삭제 SQL(hcm.kpi.kpiMng.deleteFeedback)은 WHERE YEAR = #{findYear} 를 사용함.
    // AS-IS kpiMngList.jsp 도 findYear 를 전송 — year 만 보내면 0행 삭제로 실패함.
    params.append('findYear', year);
    params.append('year', year);
    params.append('kpiId', kpiId);
    params.append('mon', mon);

    return useApi('/api/hcm/kpi/kpiMng/deleteFeedback.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 전체 보드-카테고리 목록 조회 API (새 업무 등록용)
   * selectCategoryPlan_json.do의 categoryList는 plan이 있는 카테고리만 반환하므로,
   * selectData.do의 boardCategoryList를 사용하여 전체 카테고리 조회
   */
  const fetchAllBoardCategoryList = () => {
    return useApi('/api/hcm/avt/avtMng/selectData.do', {
      method: 'GET',
    });
  };

  /**
   * 새 업무(Plan) 등록 API
   * @param boardId - 보드 ID
   * @param categoryId - 카테고리 ID
   * @param planNm - 업무명
   */
  const insertNewPlan = (boardId: string, categoryId: string, planNm: string) => {
    const params = new URLSearchParams();
    params.append('boardId', boardId);
    params.append('categoryId', categoryId);
    params.append('planNm', planNm);

    return useApi('/api/hcm/avt/avtMng/insertPlan.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // 매니저 KPI 관련 API
  // ============================================

  /**
   * 매니저 KPI 목록 조회 API
   *
   * @param findYear - 조회연도
   * @param userId - 사용자 ID (선택)
   *
   * @returns Promise<ManagerKpiListResponse>
   */
  const fetchManagerKpiList = (findYear: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/selectManagerKpiData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 매니저 KPI 수락 API
   *
   * @param findYear - 조회연도
   * @param managerKpiId - 매니저 KPI ID
   *
   * @returns Promise<AcceptManagerKpiResponse>
   */
  const acceptManagerKpi = (findYear: string, managerKpiId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('year', findYear);
    params.append('managerKpiId', managerKpiId);

    return useApi('/api/hcm/kpi/kpiMng/insertManagerKpiData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 매니저 KR 목록 조회 API
   *
   * @param findYear - 조회연도
   * @param findCycleId - 분기 ID (필수 — AS-IS와 동일)
   *
   * @returns Promise<{ managerKrList: ManagerKrItem[] }>
   */
  const fetchManagerKrList = (findYear: string, findCycleId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);

    return useApi('/api/hcm/kpi/kpiMng/selectManagerKrData_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 매니저 KR 수락 API
   *
   * @param year - 연도
   * @param cycleId - 분기 ID
   * @param managerKrId - 매니저 KR ID
   * @param objId - 목적(Objective) ID
   */
  const acceptManagerKr = (year: string, cycleId: string, managerKrId: string, objId: string) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('managerKrId', managerKrId);
    params.append('objId', objId);

    return useApi('/api/hcm/kpi/kpiMng/insertManagerKrData.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * 목표 로그 조회 API
   * @param findYear - 조회연도
   * @param krId - KR ID
   */
  const fetchObjLogList = (findYear: string, krId: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('krId', krId);

    return useApi('/api/hcm/common/log/objLogList.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  // ============================================
  // OKR 복사/이동 API (#2193)
  // ============================================

  /**
   * KR 복사/이동 대상 목적(Objective) 목록 조회 API
   *
   * @description AS-IS selectCopyObjectiveList_json — KR 복사/이동 시 선택한 대상 분기의
   *   목적 목록을 조회한다. (복사·이동 팝오버의 목적 select 옵션)
   *
   * @param findYear - 연도
   * @param findCycleId - 대상 분기 ID (사용자가 선택한 복사/이동 대상 분기)
   * @param userId - 대상 사용자 ID (본인 KR 이므로 소유자 ID)
   *
   * @returns Promise<{ objList: { objId, objNm }[] }>
   */
  const fetchCopyTargetObjList = (findYear: string, findCycleId: string, userId?: string) => {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('findCycleId', findCycleId);
    if (userId) params.append('userId', userId);

    return useApi('/api/hcm/kpi/kpiMng/selectCopyObjectiveList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 복사 실행 API (다른 분기+목적으로 KR 행만 복사)
   *
   * @description AS-IS copyKr — KR 행만 INSERT-new. 활동/피드백/가중치 등은 복사되지 않음.
   *
   * @param year - 연도 (원본=대상 동일)
   * @param cycleId - 원본 분기 ID
   * @param copyCycleId - 대상 분기 ID
   * @param copyObjId - 대상 목적 ID
   * @param krId - 복사할 원본 KR ID
   *
   * @returns Promise<SaveResponse>
   */
  const copyKr = (
    year: string,
    cycleId: string,
    copyCycleId: string,
    copyObjId: string,
    krId: string,
  ) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('copyCycleId', copyCycleId);
    params.append('copyObjId', copyObjId);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/copyKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  /**
   * KR 이동 실행 API (다른 분기+목적으로 KR 이동)
   *
   * @description AS-IS moveKr — KR의 OBJ_ID/CYCLE_ID를 재할당(UPDATE-move). 피드백·연계도 함께 이동.
   *   (활동은 KR_ID 참조라 자동으로 따라감)
   *
   * @param year - 연도
   * @param cycleId - 원본 분기 ID
   * @param moveCycleId - 대상 분기 ID
   * @param moveObjId - 대상 목적 ID
   * @param krId - 이동할 KR ID
   *
   * @returns Promise<UpdateResponse>
   */
  const moveKr = (
    year: string,
    cycleId: string,
    moveCycleId: string,
    moveObjId: string,
    krId: string,
  ) => {
    const params = new URLSearchParams();
    params.append('year', year);
    params.append('cycleId', cycleId);
    params.append('moveCycleId', moveCycleId);
    params.append('moveObjId', moveObjId);
    params.append('krId', krId);

    return useApi('/api/hcm/kpi/kpiMng/moveKr.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
  };

  return {
    // KPI ?�드�?관??
    fetchKpiFeedback, // KPI ?�드�??�세 조회
    fetchKpiFeedbackMonList, // KPI ?�드�??�록 가????조회
    saveKpiFeedback, // KPI ?�드�??�??
    deleteKpiFeedback, // KPI ?�드�???��

    // 로그???�용???�보
    fetchLoginUserInfo,
    fetchKpiList, // KPI 목록 조회
    // KPI 합의(Agreement)
    fetchAgreementYn, // 합의 기능 사용 여부 조회
    fetchKpiConfigTermYn, // KPI 등록/수정 기간 여부 조회
    saveAgreement, // 합의 상태 저장
    fetchActualList, // ?�별 ?�적 목록 조회
    fetchActual, // ?�적 ?�세 조회
    saveActual, // ?�적 ?�??
    deleteActual, // ?�적 ??��
    fetchActualMonthList, // 추�? 가????목록 조회
    fetchTaskList, // KPI 매핑 ?�무 조회
    fetchTaskActivityList, // ?�무 ?�동 조회
    fetchOkrList, // KPI 매핑 OKR 조회
    fetchOkrTaskMapping, // OKR 매핑 ?�무 조회
    fetchKrPlanList, // KR ?�결 Plan 목록 조회 (분기 ?�함)
    fetchObjPlanJson, // KR 활동탭 (planDatas + activityDatas)

    // ??목표 추�? 관??
    fetchUpKpiList, // ?�위 KPI 목록 조회
    fetchDeptKpiList, // 부??KPI 목록 조회
    fetchRefKpiList, // 참고 KPI 목록 조회
    saveKpi, // KPI ?�??(?�규/?�정)
    deleteKpi, // KPI ??��
    copyKpi, // KPI 복사 실행 (다른 연도로 마스터 행만 복사)

    // ?�과 ?�동 관??
    fetchLinkableOkrList, // ?�결 가?�한 OKR 목록 조회 (?�터 ?�널?�서???�용)
    fetchLinkablePlanList, // ?�결 가?�한 ?�무 목록 조회
    fetchShareUserList, // 공유 ?�???�용??목록 조회
    fetchPrevYearKpiList, // ?�전?�도 KPI 목록 조회
    acceptDistributeKpi, // 배포 KPI ?�락

    // OKR 분기(Cycle) 관??
    fetchCycleList, // 분기 목록 조회
    fetchOkrListByCycle, // 분기�?OKR 목록 조회

    // OKR(KR) 관??
    insertOkr, // OKR ?�??(?�규)
    updateOkr, // OKR ?�정
    deleteOkr, // OKR ??��
    fetchKrDetail, // KR ?�세 조회
    fetchKrStatusList, // KR ?�태 목록 조회

    // KR 관계맺기 관련
    fetchRelKrManagerList, // 관계맺기 매니저 목록 조회
    fetchRelationKrList, // 관계맺기 KR 목록 조회
    fetchKrGanttList, // KR 타임라인(간트) 조회
    fetchCascadingKrList, // 연계도 대상 KR 목록 조회 (셀렉트용)
    fetchKrCascadingTree, // KR 연계도(Cascading) 트리 XML 조회

    // OKR ?�드�?관??
    fetchUpdateKrFeedbackRead, // KR 피드백 읽음 처리
    fetchOkrFeedback, // ?�드�?조회
    saveOkrFeedback, // ?�드�??�??
    deleteOkrFeedback, // ?�드�???��

    // 구성???�리 관??
    fetchMemberTreeList, // 구성???�리 목록 조회
    fetchKpiLinkData, // KPI ?�하???�결관�?조회

    // 검??조건 관??(관리자??
    fetchKpiDeptList, // 부??목록 조회
    fetchKpiUserList, // ?�용??목록 조회 (부??기�? ?�위 ?�함)

    // ?�스???�정 관??
    fetchKpiStatusList, // KPI 진행?�태 목록 조회

    // ?�서 변�?
    updateKpiSortOrder, // KPI ?�렬?�서 ?�정
    updateObjSortOrder, // Objective ?�렬?�서 ?�정
    updateKrSortOrder, // KR ?�렬?�서 ?�정

    // 배포받은 목록 조회
    fetchDistributeKpiList,
    fetchDistributeKrList,
    acceptDistributeKr,

    // KPI 기�? ?�정 조회
    fetchAllUserList,
    fetchKpiSetting,
    saveKpiSetting, // KPI ?�정 ?�??
    fetchOkrSetting, // OKR 설정 조회
    saveOkrSetting, // OKR 설정 저장

    // Objective ?�??
    saveObjective,
    deleteObjective, // Objective(목적) 삭제
    linkKpiKr, // KPI-KR 연계 저장

    // 구성원/공유자 목록 조회 (MemberPanel 탭용)
    fetchMemberShareList,

    // KR 결 Plan 저장
    saveKrPlan,

    // 새 업무(Plan) 등록
    insertNewPlan,

    // 전체 보드-카테고리 목록 조회 (새 업무 등록용)
    fetchAllBoardCategoryList,

    // 목표 로그 조회
    fetchObjLogList,

    // 매니저 KPI 관련
    fetchManagerKpiList,
    acceptManagerKpi,

    // 매니저 KR 관련
    fetchManagerKrList,
    acceptManagerKr,

    // OKR 복사/이동 (#2193)
    fetchCopyTargetObjList, // KR 복사/이동 대상 목적 목록 조회
    copyKr, // KR 복사 실행
    moveKr, // KR 이동 실행
  };
};
